import styled, {css} from "styled-components"

export const ToastErrorContainer = styled.div`
  ${({theme}) => css`
    background: ${theme.colors.greys.white};
    border-radius: ${theme.spacing.one};
    border: 0px solid ${theme.colors.tertiary.r_400};
    border-left-width: ${theme.spacing.oneAndHalf};
    margin: ${theme.spacing.two} 0 0 0;
    padding: ${theme.spacing.one} ${theme.spacing.five} ${theme.spacing.one} ${theme.spacing.two};
    position: relative;
    ${theme.mediaQueries.minWidthMedia.tablet`
      margin-left: auto;
      max-width: 320px;
    `}
  `}
`
